// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8760) return "static/chunks/8760-e5f8aa07525742c3.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7601 ? "4b5bc78c" : chunkId) + "." + {"4928":"bfacf84e462996c4","7601":"b084911c77fbd477"}[chunkId] + ".js";
};